import React from "react";

export default function ScorePlusFilters({ 
  filters, 
  updateFilters, 
  recordsCount = 0,
  onClearFilters 
}) {
  if (recordsCount === 0) return null;

  return (
    <div className=" bg-gray-900 border border-gray-700 rounded-xl p-4">
      <div className="flex items-center justify-between mb-4">
        <div className="text-white font-bold flex items-center gap-2">
          🔍 Filters
        </div>
        <div className="flex items-center gap-3 text-xs">
          <span className="text-gray-200">{recordsCount} records</span>
          <button
            onClick={onClearFilters}
            className="text-cyan-400 hover:text-cyan-300 underline"
          >
            Clear All
          </button>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3">
        <div className="flex flex-col">
          <label className="text-xs text-gray-200">From Date</label>
          <input
            type="date"
            value={filters.fromDate || ""}
            onChange={(e) => updateFilters("fromDate", e.target.value)}
            className="w-full bg-gray-800 text-white rounded px-2 py-1"/>
        </div>

        <div className="flex flex-col">
          <label className="text-xs text-gray-200">To Date</label>
          <input
            type="date"
            value={filters.toDate || ""}
            onChange={(e) => updateFilters("toDate", e.target.value)}
            className="w-full bg-gray-800 text-white rounded px-2 py-1"/>
        </div>

        <div className="flex flex-col">
          <label className="text-xs text-gray-200">Status</label>
          <select
            value={filters.status || ""}
            onChange={(e) => updateFilters("status", e.target.value)}
            className="w-full bg-gray-800 text-white rounded px-2 py-1">
            <option value="">All Status</option>
            <option value="Done">✅ Done</option>
            <option value="Partial">⚠️ Partial</option>
            <option value="Missed">❌ Missed</option>
          </select>
        </div>

        <div className="flex flex-col">
          <label className="text-xs text-gray-200">Activity</label>
          <input
            type="text"
            placeholder="activity..."
            value={filters.activity || ""}
            onChange={(e) => updateFilters("activity", e.target.value)}
            className="block w-full bg-gray-800 text-white rounded px-2 py-1"
          />
        </div>

        <div className="flex flex-col lg:flex-row gap-2 ">
          <div className="flex flex-col">
            <label className="text-xs text-gray-200">Expert</label>
            <input
              type="text"
              placeholder="viewerCode1..."
              value={filters.viewerCode1 || ""}
              onChange={(e) => updateFilters("viewerCode1", e.target.value)}
              className="block w-full bg-gray-800 text-white rounded px-2 py-1"
            />
          </div>

          <div className="flex flex-col">
            <label className="text-xs text-gray-200">Company</label>
            <input
              type="text"
              placeholder="viewerCode2..."
              value={filters.viewerCode2 || ""}
              onChange={(e) => updateFilters("viewerCode2", e.target.value)}
              className="block w-full bg-gray-800 text-white rounded px-2 py-1"
            />
          </div>
        </div>

        <div className="flex flex-col">
          <label className="text-xs text-gray-200">Tag</label>
          <input
            type="text"
            placeholder="coding, workout..."
            value={filters.tag || ""}
            onChange={(e) => updateFilters("tag", e.target.value)}
            className="block w-full bg-gray-800 text-white rounded px-2 py-1"
          />
        </div>

        <div className="flex flex-col">
          <label className="text-xs text-gray-200">Duration</label>
          <select
            value={filters.duration || ""}
            onChange={(e) => updateFilters("duration", e.target.value)}
            className="w-full bg-gray-800 text-white rounded px-2 py-1"
          >
            <option value="">All Durations</option>
            <option value="30">Under 30 min</option>
            <option value="60">30-60 min</option>
            <option value="180">1-3 Hours</option>
            <option value="181">3+ Hours</option>
          </select>
        </div>
      </div>
    </div>
  );
}